import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import '../styles/Services.scss'
import '../styles/styles.scss'
import JobDetailsModal from './JobDetailsModal'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UpdateAvailabilityModal from '../modals/UpdateAvailabilityModal'
import FilterIcon from '../assets/imgs/stylers-images/filter-icon.svg'
import ServicesCard from './Cards/ServicesCard'
import Image1 from '../assets/imgs/stylers-images/image1.png'
import { getDataById } from '../apis/generalApis'
import { ScaleLoader } from 'react-spinners'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function Services() {
  const user = JSON.parse(localStorage.getItem('user'))
  // console.log({ user })
  const [openAvailabilityModal, setOpenAvailabilityModal] = React.useState(
    false,
  )
  const [jobDetailsModal, setJobDetailsModal] = React.useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [sortByOption, setSortByOption] = React.useState({
    label: 'Months',
    value: '',
  })
  const [cardImage, setCardImage] = React.useState(Image1)
  const [stylistPastBookings, setStylistPastBookings] = React.useState([])
  const [
    stylistScheduledBookings,
    setStylistScheduledBookings,
  ] = React.useState([])
  const [sortDropdown, setSortDropdown] = React.useState({
    opened: false,
    activeOption: 0,
  })

  useEffect(() => {
    // getStylistPastBookings()
    getStylistScheduledBookings()
  }, [])

  useEffect(() => {
    if (sortByOption.value !== '' && sortByOption?.value != null) {
      getStylistPastBookings(sortByOption?.value)
    } else {
      getStylistPastBookings()
    }
  }, [sortByOption])

  const getStylistPastBookings = async (sortOption) => {
    let body = { stylist_id: user?.id }
    if (sortOption) {
      body.month = sortOption
    }
    let result
    if (sortOption) {
      setIsLoading(true)
      result = await getDataById('show-stylist-past-booking', body)
      setIsLoading(false)
    } else {
      setIsLoading(true)
      result = await getDataById('show-stylist-past-booking', body)
      setIsLoading(false)
    }
    if (result?.success === true && result?.data) {
      setStylistPastBookings(result?.data)
    }
  }

  const getStylistScheduledBookings = async () => {
    let body = { stylist_id: user?.id }
    setIsLoading(true)
    let result = await getDataById('show-stylist-schedule-booking', body)
    setIsLoading(false)
    if (result?.success === true) {
      setStylistScheduledBookings(result?.data.reverse())
    }
  }

  const handleJobDetailsModal = () => {
    setJobDetailsModal(!jobDetailsModal)
  }

  const [activeTab, setActiveTab] = React.useState(0)
  const [selectedBooking, setSelectedBooking] = React.useState(null)

  const toggleSortDropdown = () => {
    setSortDropdown((previousState) => {
      return { ...previousState, opened: !previousState.opened }
    })
  }

  const toggleUpdateAvailabilityModal = () => {
    setOpenAvailabilityModal(!openAvailabilityModal)
  }

  const dropdownOptions = [
    {
      label: 'For How Long?',
      value: null,
    },
    {
      label: '1 Month',
      value: 1,
    },
    {
      label: '3 Months',
      value: 3,
    },
    {
      label: '6 Months',
      value: 6,
    },
    {
      label: '1 Year',
      value: 12,
    },
    {
      label: 'All Time',
      value: '',
    },
  ]

  return (
    // <ThemeProvider theme={theme}>
    <div
      style={{ backgroundColor: '#F5F5F5' }}
      className="services-component-container"
    >
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="nav-services services-section">
        <div className="container">
          {activeTab === 0 && (
            <Box>
              <div className="row pt-3">
                <div className="col-0 col-sm-0 col-md-4"></div>
                <div className="col-12 xol-sm-12 col-md-4">
                  <div className="update-availability py-2 px-5 text-center">
                    <p className="update-availability-text m-0 fs-18">
                      Update your availability to <br /> receive new clients
                    </p>
                  </div>
                </div>
                <div className="col-12 xol-sm-12 col-md-4 align-self-center text-center text-md-end mt-3 mt-sm-3 mt-md-0">
                  <Button
                    disableElevation
                    id="btn-primary"
                    variant="contained"
                    className="commonBtn px-5 py-md-0 py-sm-4 py-4 br-16"
                    onClick={toggleUpdateAvailabilityModal}
                  >
                    Update Availability
                  </Button>
                </div>
              </div>
            </Box>
          )}
          <div className="custom-tabs d-flex flex-wrap justify-content-center justify-content-md-between justify-content-sm-center mt-4 px-4">
            <div className="d-flex">
              <div
                className={`tab ${activeTab === 0 ? 'active-tab' : ''}`}
                onClick={() => setActiveTab(0)}
              >
                <p className="fs-18 color-primary">Current</p>
              </div>
              <div
                className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                onClick={() => setActiveTab(1)}
              >
                <p className="fs-18 color-primary">Past</p>
              </div>
            </div>
            {activeTab === 1 && (
              <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center">
                <div
                  onClick={toggleSortDropdown}
                  className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center bg-white"
                >
                  <p className="m-0 font-weight-bold textwh">Sort By</p>
                  <p className="m-0 color-primary d-flex align-items-center gap-1">
                    <span className='mt-1'>{sortByOption?.label}</span>
                    <span>
                      <KeyboardArrowDownIcon />
                    </span>
                  </p>
                </div>
                {sortDropdown.opened && (
                  <div className="dropdown-content">
                    {dropdownOptions.map((item, index) => (
                      <div
                        key={index}
                        className={`dropdown-option hover-div ${
                          sortDropdown.activeOption === index
                            ? 'active-dropdown-option'
                            : ''
                        }`}
                        onClick={() => {
                          if (item?.value !== null) {
                            setSortDropdown((prev) => ({
                              ...prev,
                              opened: false,
                              activeOption: index,
                            }))
                            setSortByOption(item)
                          }
                        }}
                      >
                        <p className="fs-12">{item?.label}</p>
                      </div>
                    ))}
                  </div>
                )}
                <div className="filter d-flex align-items-center">
                  <img src={FilterIcon} alt="" className="px-2" height={15} />
                  <h3 className="m-0" style={{ fontSize: '1.4rem' }}>
                    Filters
                  </h3>
                </div>
              </div>
            )}
          </div>
          {activeTab === 0 && (
            <div className="mt-3 cardsWrapper">
              <div className="row cards-wrapper pb-3 g-3">
                {stylistScheduledBookings &&
                  stylistScheduledBookings.length > 0 &&
                  stylistScheduledBookings?.map((booking, index) => (
                    <div
                      className="col-12 col-sm-12 col-md-6 col-lg-4"
                      key={booking?.id}
                    >
                      <div
                        className="services-card-wrapper"
                        // onClick={() => {
                        //   setSelectedBooking(booking)
                        //   handleJobDetailsModal()
                        // }}
                      >
                        <ServicesCard
                          showDistance={true}
                          booking={booking}
                          setSelectedBooking={setSelectedBooking}
                          handleJobDetailsModal={handleJobDetailsModal}
                          getStylistScheduledBookings={
                            getStylistScheduledBookings
                          }
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          {activeTab === 1 && (
            <div className="my-4 cardsWrapper">
              <div className="row cards-wrapper2 g-3">
                {stylistPastBookings &&
                  stylistPastBookings?.map((booking, index) => (
                    <div
                      className="col-12 col-sm-12 col-md-6 col-lg-4"
                      key={booking?.id}
                    >
                      <div className="services-card-wrapper">
                        <ServicesCard booking={booking} />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
        <JobDetailsModal
          handleJobDetailsModalToggle={handleJobDetailsModal}
          modalOpen={jobDetailsModal}
          cardImage={cardImage}
          booking={selectedBooking}
          setSelectedBooking={setSelectedBooking}
          getStylistScheduledBookings={getStylistScheduledBookings}
        />
        <UpdateAvailabilityModal
          toggleUpdateAvailabilityModal={toggleUpdateAvailabilityModal}
          modalOpen={openAvailabilityModal}
        />
      </div>
    </div>
  )
}

export default Services
